import { PPInput } from 'processor-plataform-ui';
import React, { useEffect, useState } from 'react';
import { WorkView } from '../../../models/WorkView';
import WorkService from '../../../services/WorkService/WorkService';
import SolicitationAttendantService from '../../../services/SolicitationAttendantService/SolicitationAttendantService';
import LCFlexContainer from '../../Layout/LCFlexContainer';
import LCFlexItem from '../../Layout/LCFlexItem';
import LcAccordion from '../LcAccordion';
import { useDispatch, useSelector } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { PrefState } from '../../../store/reducers/prefReducer';
import { RootState } from '../../../store/index';
import { TimeKeepingModel, WorkTimeKeep } from '../../../models/WorkTimeKeep';
import LcLoading from '../LcLoading';

interface Props {
    editable: boolean,
    work?: WorkView,
    solicitation?: any,
}

const TimeKeeping: React.FC<Props> = (props) => {
    const dispatch = useDispatch();
    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const workService: WorkService = new WorkService(props);
    const solicitationAttendantService: SolicitationAttendantService = new SolicitationAttendantService(props);
    const [disableButton, setDisableButton] = useState<boolean>(true);
    const [loadingTimeSave, setLoadingTimeSave] = useState<boolean>(false);
    
    const [timeKeeping, setTimeKeeping] = useState<TimeKeepingModel>({
        originalEstimate: 0,
        remainingWork: 0,
        completedWork: 0
    });

    useEffect(() => {
        GetTimeKeep();
    }, [])

    useEffect(() => {
        if (props.solicitation && pref.timeKeepWork) {
            GetTimeKeep();
        }
    }, [props.solicitation, pref.timeKeepWork])


    const GetTimeKeep = async () => {
        setLoadingTimeSave(true);

        try {
            let timeResponse = await
                ((props.work?.id)
                    ? workService.GetTimeKeep(Number(props.work?.id))
                    : solicitationAttendantService.GetTimeKeep(Number(props.solicitation.id)));

            setTimeKeeping({
                ...timeKeeping,
                originalEstimate: (timeResponse.data) ? timeResponse.data.originalEstimatedTime : 0,
                remainingWork: (timeResponse.data) ? timeResponse.data.timeRemaning : 0,
                completedWork: (timeResponse.data) ? timeResponse.data.timeCompleted : 0,
            });

            dispatch({ type: "PREF_TIMEKEEP_WORK", payload: false });
        }
        catch (error) {
            console.error(error);
        }

        setLoadingTimeSave(false);
    }

    const handleSave = async () => {
        setDisableButton(true);
        setLoadingTimeSave(true);

        if (props.work) {
            try {
                var workToSave: WorkTimeKeep = {
                    IdSolicitation: props.work.idSolicitation,
                    IdWork: props.work.id,
                    IdUser: Number(props.work.idUser ?? user.id),
                    IdWorkTeam: props.work.idWorkTeam,
                    OriginalEstimatedTime: timeKeeping.originalEstimate,
                    TimeRemaning: timeKeeping.remainingWork,
                    TimeCompleted: timeKeeping.completedWork,
                };

                const timeResponse = await workService.SetTimeKeep(workToSave);

                setTimeKeeping({
                    originalEstimate: timeResponse.data.originalEstimatedTime,
                    remainingWork: timeResponse.data.timeRemaning,
                    completedWork: timeResponse.data.timeCompleted,
                });
                
                dispatch({ type: "PREF_TIMEKEEP_WORK", payload: true });
            }
            catch (e) {
                console.error(e);
                debugger;
            }
        }

        setLoadingTimeSave(false);
    }

    const handleChange = (event, field) => {
        let inputValue = event.target.valueAsNumber;

        if (inputValue < 0) {
            inputValue = 0;
        } 
        
        setTimeKeeping({ ...timeKeeping, [field]: inputValue });
        setDisableButton(false); 
    };

    return (
        <LcAccordion title="Apontamentos" visible={true} iconNormal={!props.editable}>
            <LcLoading loading={loadingTimeSave}>
                <LCFlexContainer spacing={2} direction='column'>
                    <LCFlexItem>
                        <PPInput
                            title={'Estimativa Original'}
                            type={'number'}        
                            onChange={(e) => { handleChange(e, "originalEstimate") }}          
                            value={timeKeeping.originalEstimate}
                            disabled={!props.editable}
                        />
                    </LCFlexItem>
                    <LCFlexItem>
                        <PPInput
                            title={'Tempo restante'}
                            type={'number'}
                            onChange={(e) => { handleChange(e, "remainingWork") }}  
                            value={timeKeeping.remainingWork}
                            disabled={!props.editable}
                        />
                    </LCFlexItem>
                    <LCFlexItem>
                        <PPInput
                            title={'Tempo completado'}
                            type={'number'}                          
                            onChange={(e) => { handleChange(e, "completedWork") }}  
                            value={timeKeeping.completedWork}
                            disabled={!props.editable}
                        />
                    </LCFlexItem>
                </LCFlexContainer>
                {
                    props.editable &&
                    <button
                        disabled={disableButton}
                        style={{ marginTop: '10px' }}
                        className={'lc-button bg-info'}
                        id={'Save'}
                        onClick={handleSave}
                        color={"primary"}
                    >Salvar
                    </button>
                }
            </LcLoading>
        </LcAccordion>
    )
}

export default TimeKeeping;
